import axios from './ApiService.js';

const saveUser = async (userData) => {
  const response = await axios.post('/api/users', userData);
  return response.data;
};

const deleteUser = async (userId) => {
  const response = await axios.delete(`/api/users/${userId}`);
  return response.data;
};

const getUserLibraryNetwork = async (userId, libraryId) => {
  const params = libraryId ? { library_id: libraryId } : {};
  const response = await axios.get(`/api/user_library_network/${userId}`, { params });
  return response.data;
};

const updateUser = async (userId, userData) => {
  const response = await axios.patch(`/api/users/${userId}`, userData);
  return response.data;
};

const getUserAccesses = async (userId) => {
  const response = await axios.get(`/api/users/${userId}/accesses`);
  return response.data;
};

// FBKS-4003: removes only the user's access to one library/network/retailer.
// ApiService.delete() takes no config, so the params go in the URL.
const removeUserAccess = async (userId, params) => {
  const response = await axios.delete(`/api/users/${userId}/access?${new URLSearchParams(params)}`);
  return response.data;
};

export { saveUser, deleteUser, updateUser, getUserLibraryNetwork, getUserAccesses, removeUserAccess };
